export const COLORS = {
    RED: '#e24545',
    YELLOW: '#ffc107',
    ORANGE: '#f2aa3e',
    GREEN: '#198754',
    GRAY: '#6c757d'
};


export const hexToRgb = (hex, opacity) => {
    hex = hex.replace('#', '');

    if (hex.length === 3) {
        hex = hex.split('').map(h => h + h).join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return `rgb(${r}, ${g}, ${b}, ${opacity})`;
}


export const processValue = (value) => {
    if (typeof value === 'number') {
        if (value.toString() == 'NaN') {
            return "-"
        }
        else if (Number.isInteger(value)) {
            return value; // whole number
        } else {
            return parseFloat(value.toFixed(1)); // rounded to 2 decimal places
        }
        
    } else if (typeof value === 'string') {
        return value;
    } else {
        return "-";
    }
}


// Parameter status indicator
export const getStatusColor = (value) => {
    if (!value) return 'secondary'; // Default color if value is not provided
    switch (value.toLowerCase()) {
        case 'excellent':
        case 'good':
        case 'normal':
            return 'success';
        case 'moderate':
        case 'low':
            return 'warning';
        case 'poor':
        case 'critical':
            return 'danger';
        default:
            return 'secondary';
    }
};




export const getStatusHexColor = (value) => {
    switch (value.toLowerCase()) {
        case 'excellent':
        case 'good':
        case 'normal':
            return COLORS.GREEN;
        case 'moderate':
            return COLORS.YELLOW;
        case 'low':
        case 'poor':
        case 'critical':
            return COLORS.RED;
        default:
            return COLORS.GRAY;
    }
};


export const toCamelCaseWithSpaces = (text) => {
    return text
        .replace(/[_-]+/g, ' ')                       // Replace underscores and hyphens with space
        .replace(/\s+/g, ' ')                         // Normalize multiple spaces to one
        .trim()                                       // Trim leading/trailing spaces
        .split(' ')                                   // Split by space
        .map(word => word.charAt(0).toUpperCase() +
            word.slice(1).toLowerCase())     // Capitalize each word
        .join(' ');                                   // Join back with space
}


export const toUpperCaseWithSpaces = (text) => {
    return text
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
}

